import { Controller } from '@hotwired/stimulus';

// Sticky header: adds a border once the page scrolls and toggles the mobile menu.
export default class extends Controller {
  static targets = ['menu', 'toggle', 'openIcon', 'closeIcon'];

  connect() {
    this.onScroll = this.onScroll.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    document.addEventListener('keydown', this.onKeydown);
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('keydown', this.onKeydown);
  }

  onScroll() {
    this.element.classList.toggle('is-scrolled', window.scrollY > 8);
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) this.close();
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.setOpen(true);
  }

  close() {
    this.setOpen(false);
  }

  setOpen(open) {
    this.menuTarget.hidden = !open;
    this.toggleTarget.setAttribute('aria-expanded', String(open));
    this.openIconTarget.classList.toggle('hidden', open);
    this.closeIconTarget.classList.toggle('hidden', !open);
    document.body.classList.toggle('overflow-hidden', open);
  }

  get isOpen() {
    return !this.menuTarget.hidden;
  }
}
